import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Seo from '../components/Seo'
import './not-found.css'

const NotFound = () => {
  return (
    <div className="page">
      <Seo title="Page not found" path="/404" description="The page you requested could not be found." />
      <Navbar />
      <main className="not-found">
        <div className="container not-found__inner">
          <p className="not-found__code">404</p>
          <h1 className="not-found__title">Page not found</h1>
          <p className="not-found__text">
            That URL does not exist on this site. Head home or browse our services.
          </p>
          <div className="not-found__actions">
            <Link to="/" className="btn btn-primary">
              Go home
            </Link>
            <Link to="/services" className="btn btn-outline">
              Services
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default NotFound
